import axios from 'axios';

const SITES_API = `${process.env.VUE_APP_API_URL}/v1/pricing`;

export const getProducts = (currency) => axios.get(`${SITES_API}/products`, { params: { currency } }).then((result) => result.data);
